"use strict";

var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alertTokens = void 0;
var _types = require("./types");
var alertTokens = function alertTokens(theme) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _types.AlertType.INFORMATION, {
    background: theme.comp.alerts.color.background.information,
    barColor: theme.comp.alerts.color.bar.information,
    borderColor: theme.comp.alerts.color.border.information,
    iconColor: theme.comp.alerts.color.semanticicon.information,
    icon: 'info'
  }), _types.AlertType.SUCCESS, {
    background: theme.comp.alerts.color.background.success,
    barColor: theme.comp.alerts.color.bar.success,
    borderColor: theme.comp.alerts.color.border.success,
    iconColor: theme.comp.alerts.color.semanticicon.success,
    icon: 'checkCircle'
  }), _types.AlertType.WARNING, {
    background: theme.comp.alerts.color.background.warning,
    barColor: theme.comp.alerts.color.bar.warning,
    borderColor: theme.comp.alerts.color.border.warning,
    iconColor: theme.comp.alerts.color.semanticicon.warning,
    icon: 'warning'
  }), _types.AlertType.ERROR, {
    background: theme.comp.alerts.color.background.error,
    barColor: theme.comp.alerts.color.bar.error,
    borderColor: theme.comp.alerts.color.border.error,
    iconColor: theme.comp.alerts.color.semanticicon.error,
    icon: 'error'
  });
};
exports.alertTokens = alertTokens;